
var DiagrammingView = (function () {
  var COPYRIGHT = "(c) Copyright The Australian e-Health Research Centre, CSIRO, 2014",
    dcontainer,
    onclick,
    debounce,
    listeners = [],
    ep;

  const denyProps = [
    'child',
    'normalForm',
    'normalFormTerse',
    'sufficientlyDefined',
    // 'moduleId',
    // 'effectiveTime',
  ];

  return {
    settings: {
      selector: "dcontainer",
      onclick: undefined,
      Endpoint: undefined,
    },

    init: function () {
      var s = this.settings;

      onclick = s.onclick;
      dcontainer = document.getElementById(s.selector);

      ep = s.Endpoint;
    },
    
    showConcepts: function (concepts) {
      // console.clear();
      debounce = Math.random();

      while (dcontainer.firstChild) {
        dcontainer.removeChild(dcontainer.firstChild);
      }

      return concepts.map(c => render(dcontainer, c));
    },

    // addListener: function (listener) { listeners.push(listener); },
  };

  // function invokeCallback(d) {
  //   listeners.forEach(function (callback) {
  //     try {
  //       callback(d.shortId);
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   });
  // }

  function zip(arrays) {
    return arrays[0].map(function (_, i) {
      return arrays.map(function (a) { return a[i] })
    });
  }

  function isDefined(val) {
    return typeof val !== 'undefined';
  }

  /*
   * returns a list of props which are key-value sequences; values are type and possibly nested
   *
   * updates labels; a map from code to display text
   */
  function getProps(labels, part, baseCoding) {
    let kind, prop, propName, val = [], unk = false;
    part.forEach(pa => {
      if ('code' === pa.name) {
        propName = prop = pa.valueCode;
        labels[prop] = {...baseCoding, c: pa.valueCode};
      } else if ('subproperty' === pa.name) {
        prop = 'group';
        kind = 'd-group'
        val.unshift(getProps(labels, pa.part, baseCoding));
      } else if (isDefined(pa.valueCode)) {
        kind = 'd-attr'
        val = pa.valueCode;
        labels[val] = {...baseCoding, c: pa.valueCode};
      } else if (isDefined(pa.valueCoding)) {
        kind = 'd-attr'

// FIXME hack
// if (!pa.valueCoding.version && 'http://snomed.info/sct' === pa.valueCoding.system) {
//   pa.valueCoding.version = 'http://snomed.info/sct/83821000000107';
// }

        val = pa.valueCoding.version
          ? pa.valueCoding.system + '|' + pa.valueCoding.version + '#' + pa.valueCoding.code
          : pa.valueCoding.system + '#' + pa.valueCoding.code;
        labels[val] = {c: pa.valueCoding.code, s: pa.valueCoding.system, v: pa.valueCoding.version};
      } else if (isDefined(pa.valueString)) {
        kind = 'd-prop'
        val = pa.valueString;
      } else if (isDefined(pa.valueUri)) {
        kind = 'd-prop'
        val = pa.valueUri;
      } else if (isDefined(pa.valueDateTime)) {
        kind = 'd-prop'
        val = pa.valueDateTime;
      } else if (isDefined(pa.valueDecimal)) {
        kind = 'd-prop'
        val = pa.valueDecimal;
      } else if (isDefined(pa.valueInteger)) {
        kind = 'd-prop'
        val = pa.valueInteger + '';
      } else if (isDefined(pa.valueBoolean)) {
        kind = 'd-prop'
        val = pa.valueBoolean;
      } else if (isDefined(pa.value)) {  // TODO check this case?
        kind = 'd-prop'
        val = pa.value;
      } else {
        console.log('UNK', prop, /* kind, val, */ pa, part)
        unk = true;
      }
    })

    const props = {};
    const p = [];
    if ('d-group' === kind) {
      if (propName && propName !== '609096000') {
        prop = 'group.' + propName;
console.log('NAMED GROUP', prop);
      }
      props[prop] = val;
      p.unshift(val)
      p.unshift(prop)
    } else if (!unk && denyProps.indexOf(prop) === -1 && isDefined(val) && val !== false) {
      props[prop] = [kind, val];
      p.unshift([kind, val])
      p.unshift(prop)
    }
    return p;
  }

  function tr(table) {
    // return '<tr>' + tds.join('') + '</tr>'
    return table.insertRow();
  }
  function td(row, cls, cont, span) {
    const cell = row.insertCell();
    // let s = '<td';
    cell.setAttribute('class', cls || 'empty');
    // s = s + ' class="' + cls + '"';
    if (span) {
      cell.setAttribute('colspan', span);
      // s = s + ' colspan="' + span + '"';
    }
    if (cont) {
      cell.appendChild(cont);
    }
    // return s + (cont ? '>' + cont + '</td>' : '/>')
    return cell;
  }
  function sp(cls, cont, options) {
    const elt = document.createElement('span');

    if (cls) {
      elt.setAttribute('class', cls);
    }
    
    if (cont) {
      elt.appendChild(document.createTextNode(cont));

      if (options && options.title) {
        elt.setAttribute('title', options.title);
      }
      if (onclick && options && options.coding) {
// console.error('onclick', options);
        elt.onclick = (evt) => {
          onclick(options.coding, evt);
        };
        elt.style.cursor = 'pointer';
      }
    }

    return elt;
  }

  function layout(table, list, options) {
    const { start, startClass, end, endClass, before, content, after } = {
      startClass: 'd-and-down',
      ...options,
    };

    const last = list.length - 1;
    list.forEach((elt, i) => {
      const row = tr(table);
      before && before(row, i);
      if (i === 0) {
        if (start) {
          if (end && last === 0) {
            td(row, 'd-edge');
          } else {
            td(row, startClass);
          }
        } else {
          if (end && last === 0) {
            td(row, 'd-cnr-end');
          } else if (last === 0) {
            td(row, 'd-edge');
          } else {
            td(row, 'd-tee');
          }
        }
      } else if (last === i) {
        if (end) {
          td(row, 'd-cnr-end');
        } else {
          td(row, 'd-tee');
        }
      } else {
        td(row, 'd-tee')
      }
      content && content(row, elt, i);
      after && after(row, elt, i);
    });
  }

  function render(div, coding) {
    const system = coding.s, code = coding.c, version = coding.v;

    const id = debounce;

    const table = document.createElement('table');
    table.setAttribute('class', 'd-diag');

    div.appendChild(table);

    return ep.lookupConcepts({
      codings: [coding],
      fields: ['*'],
    },
      (error, rows) => {
        if (id !== debounce) return;

        if (error || !rows) return;

        const json = rows[0].resource;

        let focus;
        const labels = {};
        const items = {
          parents: [],
          groups: [],
          ungroups: [],
          others: [],
          otherGroups: [],
          otherNamedGroups: {},
        };

        function display(key) {
          const l = (labels[key] || {});
          return l.display || key;
        }

        function defStatus(key) {
          return (labels[key] || {}).sufficientlyDefined ? 'd-fd' : 'd-primitive';
        }

        function axStatus(key) {
          return (labels[key] || {}).sufficientlyDefined ? 'd-equiv' : 'd-subtype';
        }

        labels[code] = { c: code, s: system, v: version };
        const attributes = (json.parameter || [])
          .filter(p => {
            // filter out potentially large set of child properties
            if (p.name === 'property'
                && p.part
                && p.part.find(part => part.name == 'code' && part.valueCode == 'child')) {
              return false;
            }
            return true;
          })
          .filter(p => {
            if ('display' === p.name) {
              focus = p.valueString;
            }
            return 'property' === p.name;
          })
          .map(p => getProps(labels, p.part, {s: system, v: version}));

        const codeList = Object.keys(labels);
        return ep.lookupConcepts({
          codings: codeList.map(l => {
            if (labels[l].s) {
              return labels[l];
            } else {
              return { c: l, s: system, v: version };
            }
          }),
          fields: ['display','sufficientlyDefined']
        }, function (error, rows) {
          if (id !== debounce) return;

          if (error) {
            console.log('Lookup fail', error.body || error);
            return;
          }

          const json = rows;

          function mapP(coding, params) {
            const out = {
              system: coding.s,
              version: coding.v,
            };
            params.forEach(p => {
              if ('display' == p.name && p.valueString) {
                out.display = p.valueString
              } else if (p.part) {
                p.part.filter(part => typeof part.valueBoolean !== undefined).forEach(part => { out['sufficientlyDefined'] = part.valueBoolean })
              }
            })
            return out
          }

          zip([codeList, json])
            .forEach(pair => {
              const key = pair[0];
              const coding = labels[key];
              if (pair[1].response.status === "200") {
                labels[key] = mapP(coding, pair[1].resource.parameter);
              } else if (!coding.name) {
                labels[key] = {
                  system: coding.s,
                  version: coding.v,
                  display: coding.c,
                  unknown: true
                }
              }
            });

          attributes.forEach(props => {
            const name = props[0];

            if (name == 'parent') {
              items.parents.unshift(props[1]);
            } else if (name == 'group') {
              const defGrp = props[1].find(p => p[0] != display(p[0]));
              if (defGrp) {
                // defining group (e.g., SCT)
                items.groups.unshift(props[1]);
              } else {
                // non-defining group
                items.otherGroups.unshift(props[1]);
              }
            } else if (name && name.startsWith('group.')) {
              const group = name.substring(6);
              if (!items.otherNamedGroups[group]) {
                items.otherNamedGroups[group] = [];
              }
              items.otherNamedGroups[group].unshift(props[1]);
            } else if (name != display(name)) {
              items.ungroups.unshift(props);
            } else {
              items.others.unshift(props);
            }
          })

          const oth = items.others.filter(o => o.length > 0);

          const and = items.parents.length + items.groups.length + oth.length > 1;

          const axiom = axStatus(code);
          const focusCell = td(tr(table), axiom+'-focus', null, 5);
          focusCell.appendChild(sp('d-strut'))
          focusCell.appendChild(sp(defStatus(code), display(code), { title: code }))


          const displayCmp = (a, b) => display(a).localeCompare(display(b));

          const parentIsFirst = items.parents.length > 0;
          const groupIsFirst = !parentIsFirst && items.groups.length > 0;
          const ungroupIsFirst = !parentIsFirst && !groupIsFirst && items.ungroups.length > 0;
          const otherIsFirst = true;

          const otherIsLast = true;
          const ungroupIsLast = items.ungroups.length > 0;
          const groupIsLast = !ungroupIsLast && items.groups.length > 0;
          const parentIsLast = !ungroupIsLast && !groupIsLast && items.parents.length > 0;

          items.parents.sort((a, b) => displayCmp(a[1], b[1]))
          layout(table, items.parents, {
            start: parentIsFirst,
            end: parentIsLast,
            before: (row, i) => 0 == i ? td(row, axiom) : td(row),
            content: (row, elt, i) => {
              td(row, 'd-arrow');
              const cell = td(row, 'd-parent', null, 2) //sp(defStatus(elt[1]), display(elt[1]), { title: elt[1], coding: {c:elt[1],s:system,v:version} }), 2);
              cell.appendChild(sp(defStatus(elt[1]), display(elt[1]), { title: elt[1], coding: {c:elt[1],s:system,v:version} }))
              cell.appendChild(sp('d-strut'))
            }
          })

          const groupCmp = (a, b) => {
            const ta = a[1][0];
            const tb = b[1][0];
            if (ta === 'd-prop') {
              if (tb === 'd-prop') {
                const pc = displayCmp(a[0], b[0])
                if (pc === 0) {
                  return displayCmp(a[1][1], b[1][1])
                } else {
                  return pc
                }
              } else {
                return 1;
              }
            } else if (tb == 'd-prop') {
              return -1;
            }

            const pc = displayCmp(a[0], b[0])
            if (pc === 0) {
              return displayCmp(a[1][1], b[1][1])
            } else {
              return pc
            }
          };

          items.groups.forEach(g => g.sort(groupCmp));
          items.groups.sort((a, b) => b.length - a.length);

          const lastG = items.groups.length - 1;
          items.groups.forEach((g, i) => {
            const last = g.length - 1;

            g.forEach((sg, j) => {
              const name = sg[0];
              const type = sg[1][0];
              const val = sg[1][1];

              const row = tr(table);
              td(row);

              if (0 === j) {
                if (groupIsLast && lastG == i) {
                  td(row, 'd-cnr-end');
                } else {
                  td(row, 'd-tee');
                }
                td(row, 'd-group');
              } else if (groupIsLast && lastG == i) {
                td(row);
                td(row);
              } else {
                td(row, 'd-down');
                td(row);
              }
              if (0 === last) {
                td(row, 'd-edge');
              } else if (0 === j) {
                td(row, 'd-and-down');
              } else if (last === j) {
                td(row, 'd-cnr-end');
              } else {
                td(row, 'd-tee');
              }

              const cell = td(row, 'd-rel');
              if ('d-prop' === type) {
                cell.appendChild(sp(type, display(name).replace(/ reference set/, ''), { title: name, coding: {c:name,s:system,v:version} }));
                cell.appendChild(sp('d-link'));
                cell.appendChild(sp('d-value', '= ' + val));
              } else {
                cell.appendChild(sp(type, display(name), { title: name, coding: {c:name,s:system,v:version} }));
                cell.appendChild(sp('d-link'));
                cell.appendChild(sp(defStatus(val), display(val), { title: val, coding: {c:val,s:system,v:version} }));
              }
            })
          })

          layout(table, items.ungroups, {
            start: ungroupIsFirst,
            end: ungroupIsLast,
            before: (row) => { td(row) },
            content: (row, elt, i) => {
              const name = elt[0];
              const type = elt[1][0];
              const val = elt[1][1];

              const cell = td(row, 'd-rel', null, 4);
              cell.appendChild(sp('d-attr', display(name), { title: name, coding: {c:name,s:system,v:version} }));
              cell.appendChild(sp('d-link'));
              if ('d-prop' === type) {
                cell.appendChild(sp('d-value', val));
              } else {
                cell.appendChild(sp(defStatus(val), display(val), { title: val, coding: {c:val,s:system,v:version} }));
              }
            }
          })

          function unknown(key) {
            return (labels[key] || {}).unknown;
          }

          function makeCell(row, elt) {
            const nm = elt[0];
            const v = elt[1][1];
            const cell = td(row, 'd-rel', null, 4);
            cell.appendChild(sp('d-ndprop', nm));
            cell.appendChild(sp('d-link'));
            if ('d-prop' === elt[1][0]) {
              cell.appendChild(sp('d-ndvalue', v));
            } else if (v === display(v)) {
              cell.appendChild(sp('d-ndvalue', v));
            } else if (system !== v.system) {
              const cls = unknown(v) ? 'd-ndcoding d-unk' : 'd-ndcoding';
              cell.appendChild(sp(cls, display(v), { title: v, xternalcoding: { c: v, s: v.system, v: v.version } }));
            } else {
              cell.appendChild(sp('d-ndvalue', display(v), { title: v, coding: { c: v, s: system, v: version } }));
            }
          }

          function layoutOther(oth, othName) {

            oth.sort((a, b) => {
              const pc = displayCmp(a[0], b[0])
              if (pc === 0) {
                return displayCmp(a[1][1], b[1][1])
              } else {
                return pc
              }
            })

            const defs = oth.filter(elt => elt[0] === 'definition').map(elt => elt[1][1]);
            const nother = oth.length - defs.length;

            if (nother) {
              td(tr(table), 'd-strut', null, 5);
            }

            if (nother === 1 && !othName) {
              oth.filter(elt => elt[0] !== 'definition').forEach(elt => {
                const row = tr(table);
                makeCell(row, elt);
                td(row, 'd-strut');
              })
            } else {
              if (othName) {
                const cell = td(tr(table), 'd-groupname', null, 5);
                cell.appendChild(sp('d-ndprop', othName));
              }
              layout(table, oth.filter(elt => elt[0] !== 'definition'), {
                start: otherIsFirst,
                startClass: othName ? (nother > 1 ? 'd-tee' : 'd-cnr-end') : 'd-cnr-start',
                end: otherIsLast && nother > 1,
                before: (row, i) => {},//td(row),
                content: (row, elt) => {
                  // td(row, 'd-edge');
                  makeCell(row, elt);
                }
              })
            }

            defs.forEach(def => {
              const row = tr(table);
              const cell = td(row, null, null, 5);
              const html = HtmlSanitizer.SanitizeHtml(def.startsWith('<') && def.endsWith('>') ? def : `<div>${def}</div>`);
              const placeholder = document.createElement('div');
              placeholder.innerHTML = html;
              const node = placeholder.firstElementChild;
              const p = document.createElement('p');
              p.className = 'd-definition';
              p.appendChild(placeholder);
              cell.appendChild(p);
            })
          }

          items.otherGroups.forEach(grp => layoutOther(grp));

          Object.keys(items.otherNamedGroups).forEach(name => {
            items.otherNamedGroups[name].forEach(grp => {
              layoutOther(grp, name);
            })
          });

          layoutOther(oth);

          return table;
        })
      });
  }

}());

